import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router';

const LP_AUTH_ROUTE_PATHS = new Set([
  ':organizationName/login',
  ':organizationName/register',
  ':organizationName/auth/login',
  ':organizationName/auth/register',
]);

@Injectable({providedIn: 'root'})
export class LpAuthRouteReuseStrategy implements RouteReuseStrategy {
  private readonly cache = new Map<string, DetachedRouteHandle>();

  private cacheKey(route: ActivatedRouteSnapshot): string | null {
    const path = route.routeConfig?.path;
    if (!path || !LP_AUTH_ROUTE_PATHS.has(path)) return null;
    const org = route.paramMap.get('organizationName');
    return org ? `lp-auth:${org}` : null;
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.cacheKey(route) !== null;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    const key = this.cacheKey(route);
    if (key) this.cache.set(key, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = this.cacheKey(route);
    return key !== null && this.cache.has(key);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = this.cacheKey(route);
    return key ? (this.cache.get(key) ?? null) : null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}
